import CustomConfig from '../configuration/customConfig';
import { CustomEventData } from '../constants/customEventDataModel';
import { GlobalStorage } from './global';
import { isValidUrl } from './urlParamUtils';

/**
 * Returns the parameter as CustomEventData type if the parameter value was validated to be of CustomEventData type, returns null otherwise
 * @param customEventData the information about the custom event, note that param customEventData is not yet known to be a valid CustomEventData
 * @returns CustomEventData type or null type, depending on if validation succeeded or failed respectively
 */
export function validateCustomEventData(customEventData: CustomEventData): boolean {
  if (!customEventData) {
    console.error('AWSD2C: The customEventData config must be defined as an object');

    return false;
  } else {
    if (!customEventData?.event || !customEventData?.event?.type || !customEventData?.event?.name) {
      console.error('AWSD2C: The customEventData config must include an object named event that contains type and name');

      return false;
    }

    if (customEventData?.event?.type === 'pageview') {
      if (!CustomConfig.config.customPageview) {
        console.error('AWSD2C: The configuration for this website does not enable custom pageviews, but recieved a custom pageview event');
      }

      if (!customEventData?.page || !customEventData?.page?.pageURL) {
        console.error('AWSD2C: The customEventData config must include an object named page which contains pageURL for a custom pageview event');

        return false;
      }

      if (!isValidUrl(customEventData?.page?.pageURL)) {
        console.error('AWSD2C: The pageURL should be a valid URL including the protocol (http: or https:).');
      }
    } else if (customEventData?.page) {
      console.error('AWSD2C: Custom events that are not custom pageviews should not have a page object in the customEventData');
    }
  }

  return true;
}

/**
 * This function compares the customPageview customEventData pageURL with the current page URL, ensuring they are different
 * @param customEventData the information about the custom pageview event
 * @returns false if the custom pageview customEventData pageURL differs from the current pageURL, false if the two match
 */
export function compareURLCustomPageview(customEventData: CustomEventData): boolean {
  if (customEventData?.page?.pageURL !== GlobalStorage.get(GlobalStorage.PREVIOUS_PAGE_URL)) {
    return false;
  }

  console.error('AWSD2C: The custom pageview call cannot be made with the previous pageURL identical with the current pageURL.');

  return true;
}
